export default __webpack_public_path__ + "static/fishsnifferlogo-2719daff2b5feabff051df9fc4d29204.png";